// main.tsx — App entry point

// ── Self-hosted Fonts (via fontsource — no FOIT, no external requests) ──
import '@fontsource-variable/plus-jakarta-sans'; // 400-700 variable weight
import '@fontsource/playfair-display/400.css';   // Heritage / display
import '@fontsource/playfair-display/700.css';

// ── Styles (order matters) ──
import '@/styles/reset.css';
import '@/styles/tokens.css';
import '@/styles/themes/light.css';
import '@/styles/themes/dark.css';
import '@/styles/vert-or.css';      /* Vert & Or design system — after theme files */
import '@/styles/glass.css';
import '@/styles/animations.css';
import '@/styles/global.css';

// ── i18n (must initialize before React renders) ──
import '@/i18n/config';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';

async function enableMocking() {
  // MSW is opt-in via VITE_USE_MOCK=true
  // Set this in .env.development.local to use mock data instead of the real backend
  const useMock = import.meta.env['VITE_USE_MOCK'] === 'true';

  if (useMock) {
    const { worker } = await import('@/services/mock/mockServer');
    return worker.start({
      onUnhandledRequest: 'bypass', // Don't warn on unhandled (like font, asset requests)
    });
  }
  return Promise.resolve();
}

enableMocking().then(() => {
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Root element not found');

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
